import React from 'react';
import Reveal from './Reveal';

/* Ionicons outline/filled paths, matching the app (handoff §4). */
const icons = {
  // A lidded pot with a knob - the kitchen machine.
  machine: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M96 208h320v176a48 48 0 01-48 48H144a48 48 0 01-48-48z" />
      <path d="M64 208h384M256 96v48" />
      <path d="M96 144h320v64H96z" />
      <path d="M176 304v64M256 304v64M336 304v64" />
    </svg>
  ),
  // Two people - a collection for someone you cook for.
  people: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="192" cy="176" r="72" />
      <path d="M48 416c0-79.5 64.5-128 144-128s144 48.5 144 128" />
      <circle cx="368" cy="200" r="52" />
      <path d="M376 304c52 4 88 44 88 96" />
    </svg>
  ),
  // Ionicons location-outline.
  pin: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z" />
      <circle cx="256" cy="192" r="48" />
    </svg>
  ),
  send: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M470.3 20.2L28.9 226.9c-14.7 6.9-13.3 28.3 2.1 33.2l131.5 41.9 41.9 131.5c4.9 15.4 26.3 16.8 33.2 2.1L444.3 40.2" />
      <path d="M162.5 302l153.7-153.7" />
    </svg>
  ),
  calendar: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="48" y="80" width="416" height="384" rx="48" />
      <path d="M128 48v32M384 48v32M48 160h416" />
      <path d="M144 256h64M224 256h64M304 256h64M144 336h64M224 336h64" />
    </svg>
  ),
  lockscreen: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="128" y="16" width="256" height="480" rx="48" ry="48" />
      <path d="M176 176h160" />
      <path d="M176 240h160" />
    </svg>
  ),
  widget: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="48" y="48" width="176" height="176" rx="20" />
      <rect x="288" y="48" width="176" height="176" rx="20" />
      <rect x="48" y="288" width="176" height="176" rx="20" />
      <rect x="288" y="288" width="176" height="176" rx="20" />
    </svg>
  ),
  share: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="128" cy="256" r="48" />
      <circle cx="384" cy="112" r="48" />
      <circle cx="384" cy="400" r="48" />
      <path d="M169.83 279.53l172.34 96.94M342.17 135.53l-172.34 96.94" />
    </svg>
  ),
  basket: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M68.4 192A20.38 20.38 0 0048 212.2a17.87 17.87 0 00.8 5.5L100.5 400a40.46 40.46 0 0039.1 29.5h232.8a40.88 40.88 0 0039.3-29.5l51.7-182.3.6-5.5a20.38 20.38 0 00-20.4-20.2H68.4z" />
      <path d="M160 192l96-128 96 128" />
    </svg>
  ),
  flame: (
    <svg viewBox="0 0 512 512" width="22" height="22" fill="currentColor" aria-hidden="true">
      <path d="M394.23 197.56a300.43 300.43 0 00-53.37-90C301.2 61.65 249.05 32 208 32a16 16 0 00-15.48 20c13.87 53-14.88 97.07-45.31 143.72C122 234.36 96 274.27 96 320c0 88.22 71.78 160 160 160s160-71.78 160-160c0-43.3-7.32-84.49-21.77-122.44z" />
    </svg>
  ),
  stats: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="64" y="320" width="48" height="160" rx="8" />
      <rect x="288" y="224" width="48" height="256" rx="8" />
      <rect x="400" y="112" width="48" height="368" rx="8" />
      <rect x="176" y="32" width="48" height="448" rx="8" />
    </svg>
  ),
  snow: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M256 32v448M449.99 144L62.01 368M62.01 144l387.98 224" />
    </svg>
  ),
  book: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-17.93V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zM256 160v288" />
    </svg>
  ),
  mic: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M192 448h128M384 208v32c0 70.4-57.6 128-128 128s-128-57.6-128-128v-32M256 368v80" />
      <path d="M256 64a63.68 63.68 0 00-64 64v111c0 35.2 29 65 64 65s64-29 64-65V128c0-36-28-64-64-64z" />
    </svg>
  ),
  sparkles: (
    <svg viewBox="0 0 512 512" width="22" height="22" fill="currentColor" aria-hidden="true">
      <path d="M259.92 262.91L216.4 149.77a9 9 0 00-16.8 0l-43.52 113.14a9 9 0 01-5.17 5.17L37.77 311.6a9 9 0 000 16.8l113.14 43.52a9 9 0 015.17 5.17l43.52 113.14a9 9 0 0016.8 0l43.52-113.14a9 9 0 015.17-5.17l113.14-43.52a9 9 0 000-16.8l-113.14-43.52a9 9 0 01-5.17-5.17zM108 68L88 16a4 4 0 00-7.46 0L60.6 68 8.54 88a4 4 0 000 7.46L60.6 115.4 80.54 168a4 4 0 007.46 0L108 115.46 160.06 95.5a4 4 0 000-7.46zM426.67 117.33L400 48a5.33 5.33 0 00-9.95 0l-26.67 69.33L294 144a5.33 5.33 0 000 9.95l69.33 26.67L390.05 250a5.33 5.33 0 009.95 0l26.67-69.33L496 154a5.33 5.33 0 000-9.95z" />
    </svg>
  ),
  warning: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z" />
      <path d="M256 192v128" />
      <circle cx="256" cy="376" r="4" />
    </svg>
  ),
  globe: (
    <svg
      viewBox="0 0 512 512"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="256" cy="256" r="208" />
      <path d="M256 48c-58.07 0-105 93.13-105 208s46.93 208 105 208 105-93.13 105-208S314.07 48 256 48z" />
      <path d="M117.33 117.33c38.24 27.15 86.38 43.34 138.67 43.34s100.43-16.19 138.67-43.34M394.67 394.67c-38.24-27.15-86.38-43.34-138.67-43.34s-100.43 16.19-138.67 43.34M48 256h416" />
    </svg>
  ),
};

const features = [
  {
    icon: 'basket',
    title: 'Shopping list by aisle',
    copy: 'Pull ingredients from any recipe and the list regroups by where things sit in the shop - not by which recipe they came from.',
  },
  {
    icon: 'flame',
    featured: true,
    title: 'Cook mode with timers',
    copy: 'Large type, one step at a time, and every duration in the method becomes a tappable timer that survives a locked screen.',
  },
  {
    icon: 'lockscreen',
    title: 'Cook from the Lock Screen',
    copy: 'While a recipe is on the hob, the current step and every running timer sit on your Lock Screen - advance a step or check the time without unlocking.',
  },
  {
    icon: 'share',
    featured: true,
    title: 'Share a link from any app',
    copy: 'Found a recipe on TikTok, Instagram, Facebook, YouTube or the web? Share it to Snapcipe and it lands ready to import - and a link it cannot read says so up front.',
  },
  {
    icon: 'send',
    title: 'Share what you cooked',
    copy: 'One tap makes a card of the dish - the photo, the name, your own caption, the recipe if you want it on there - ready for Instagram, a group chat or a friend who asked how you made it.',
  },
  {
    icon: 'widget',
    title: 'On your home screen',
    copy: "Widgets for today's intake, your recipes, the day's plan and the people you cook for - on the Home Screen and the Lock Screen. A long-press on the icon opens the four scan modes, and Siri and Shortcuts drive them hands-free.",
  },
  {
    icon: 'stats',
    featured: true,
    title: 'Nutrition, without the data entry',
    copy: "Photograph what you ate - calories and macros land in the day's total, no weighing and no searching a database.",
  },
  {
    icon: 'calendar',
    title: 'Your week, honestly',
    copy: 'A ring for today, macros underneath, and the week behind it averaged over the days you actually logged - a skipped day is a gap, never a zero. Tap any meal to fix it in place.',
  },
  {
    icon: 'snow',
    featured: true,
    title: 'Fridge-first suggestions',
    copy: 'Scan a shelf once and Snapcipe shows what you can cook right now from what it saw - with the reason attached to every suggestion.',
  },
  {
    icon: 'book',
    title: 'Digitise the paper shelf',
    copy: 'Photograph a page from a real cookbook and it becomes a scalable, searchable, shoppable recipe.',
  },
  {
    icon: 'machine',
    title: 'Convert for your kitchen machine',
    copy: 'One tap re-sequences any recipe into the steps a Thermomix-style cooker follows - times, temperatures and speeds - and keeps the by-hand steps apart. Saved with the recipe, so reopening is free.',
  },
  {
    icon: 'mic',
    title: 'Voice through the messy bits',
    copy: '"Next step." "Start a five minute timer." "How much flour?" Answered out loud, without touching the screen.',
  },
  {
    icon: 'sparkles',
    featured: true,
    title: 'Made to fit how you eat',
    copy: 'One tap rewrites any recipe around your diet, allergies and dislikes. A scan describes what was on the plate and flags what clashes; the rewrite is yours to ask for.',
  },
  {
    icon: 'people',
    featured: true,
    title: 'Collections',
    copy: 'A plan with a breakfast, a lunch and a dinner - or the favourites of someone you cook for, checked against what they cannot eat. One tap adjusts a recipe for them, as a copy.',
  },
  {
    icon: 'pin',
    title: 'Eat local, wherever you are',
    copy: 'Where you are - or a place you name - what is worth ordering there and why, checked against your allergies. Nothing about your exact location leaves the phone.',
  },
  {
    icon: 'warning',
    title: 'Allergens flagged before you cook',
    copy: 'Scan review marks every ingredient that clashes with your allergy list - before the recipe is saved, not after the shopping is done.',
  },
  {
    icon: 'globe',
    title: 'Speaks your language',
    copy: 'English, German, French and Italian - pick yours in Settings and the whole app follows.',
  },
];

/*
 * Seventeen cards in one grid read as a wall (owner, 5 Oct: "a bit
 * overwhelming"). Six carry the product; the other eleven are still on the
 * page - a visitor who wants the whole list opens it - but as one-line rows
 * behind a native <details>, so nothing is hidden from search or from a
 * screen reader and no script runs to open it.
 */
const headline = features.filter((feature) => feature.featured);
const rest = features.filter((feature) => !feature.featured);

const Features = () => (
  <section id="features" className="section" aria-labelledby="features-headline">
    <div className="section-inner">
      <Reveal>
        <div className="eyebrow">Features</div>
        <h2 id="features-headline" className="h2 section-headline" style={{ maxWidth: '22ch' }}>
          A cookbook that knows what's in your kitchen.
        </h2>
        <div className="features-grid">
          {headline.map((feature) => (
            <div className="card" key={feature.title}>
              <div className="feature-icon-tile">{icons[feature.icon]}</div>
              <h3 className="h3">{feature.title}</h3>
              <p className="body-copy">{feature.copy}</p>
            </div>
          ))}
        </div>
        <details className="features-more">
          <summary>
            <span className="features-more-closed">And {rest.length} more</span>
            <span className="features-more-open">Fewer</span>
          </summary>
          <ul className="features-list">
            {rest.map((feature) => (
              <li key={feature.title}>
                <span className="features-list-icon">{icons[feature.icon]}</span>
                <div>
                  <h3 className="features-list-title">{feature.title}</h3>
                  <p className="body-copy">{feature.copy}</p>
                </div>
              </li>
            ))}
          </ul>
        </details>
      </Reveal>
    </div>
  </section>
);

export default Features;
